import { type RefObject } from 'preact';

import { respondWithMessage } from './respond-with-message';

export const getRespond = (gameIframeRef: RefObject<HTMLIFrameElement>) => {
  if (!gameIframeRef.current) {
    throw Error(
      'Game receiver frame is not defined. No messages could be sent to the game.'
    );
  }

  const gameReceiver = gameIframeRef.current.contentWindow;

  if (!gameReceiver) {
    throw Error(
      'ContentWindow of game receiver frame is not defined. No messages could be sent to the game.'
    );
  }

  return respondWithMessage(gameReceiver);
};
